import ShoppingCartItem from './ShoppingCartItem';

export default ShoppingCartItem;